export default {"src":"/planos/_next/static/media/equifax-users-plus.df2054d5.svg","height":18,"width":28,"blurWidth":0,"blurHeight":0};